import type { MessageParamsTyped } from 'element-plus'
import { ElMessage } from 'element-plus'
import { isString  } from '@vue/shared'

/** message 用于用户操作反馈提示 */
export const successMsg = CreateMessage('success')
export const warningMsg = CreateMessage('warning')
export const infoMsg    = CreateMessage('info')
export const errorMsg   = CreateMessage('error')

// 创建反馈消息函数
function CreateMessage(type: 'success' | 'warning' | 'info' | 'error') {
    return (options: string | MessageParamsTyped) => {
        ElMessage[type](isString(options) ? { message: options } : options)
    }
}
